<tilby-dialog-toolbar title="APPLICATION.SUPPORT_DIALOG.TITLE" [hideConfirm]="true"/>

<tilby-dialog-content>
    <h1 translate>APPLICATION.SUPPORT_DIALOG.QUESTION</h1>
    <div class="tw-flex tw-flex-col tw-gap-4">
        <button mat-raised-button color="primary" (click)="consultManuals()"
                aria-label="Consult the manuals button" cdkFocusInitial>
            <span translate>APPLICATION.SUPPORT_DIALOG.BTN_MANUALS</span>
        </button>
        <button mat-raised-button color="primary" (click)="getSupport()"
                aria-label="Get support button">
            <span>{{ (adHocCode() ? 'APPLICATION.SUPPORT_DIALOG.BTN_GET_SUPPORT' : 'APPLICATION.SUPPORT_DIALOG.BTN_GET_SUPPORT_NO_CODE') | translate:{ adHocCode: adHocCode() } }}</span>
        </button>
        <button mat-raised-button color="primary" (click)="shareScreen()"
                aria-label="Share screen button">
            <span translate>APPLICATION.SUPPORT_DIALOG.BTN_SHARE_SCREEN</span>
        </button>
    </div>
</tilby-dialog-content>

